import config from "../../config";
import { GET_CHAT, LOAD_MORE_CHAT } from "./types";

export const GetChatsAction = () => async (dispatch, getState) => {
    try {
        const headers = config.bearerHeaders(getState().auth.token);
        const res = await config.getApi(config.services.getChat(), headers);
        if (res) {
            dispatch({
                type: GET_CHAT,
                payload: res.response.data,
            });
        }
    } catch (e) {
        console.log(e);
    }
};

export const LoadMoreChatsAction = () => async (dispatch, getState) => {
    try {
        if (getState().chat.next_page_url) {
            const headers = config.bearerHeaders(getState().auth.token);
            const res = await config.getApi(
                getState().chat.next_page_url,
                headers
            );
            if (res) {
                dispatch({ type: LOAD_MORE_CHAT, payload: res.response.data });
            }
        }
    } catch (e) {
        console.log(e);
    }
};
